import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: auto;
`;

export const Main = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  overflow: auto;
`;

export const SubheaderGroup = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
`;
